import business from '../../assets/Ourapp/busniessMobile.png'
import businessDesktop from '../../assets/Ourapp/busniess.png'

interface BusniessInfoProps {
  isMobile: boolean
}

const BusniessInfo = ({ isMobile = false }: BusniessInfoProps) => {
  return (
    <div className='my-[120px] lg:my-[186px] xl:my-[240px] 2xl:my-[300px]'>
      <div
        className='flex flex-col items-center gap-12 w-full p-5 
             lg:flex-row lg:justify-between lg:w-full  lg:p-10
              xl:px-40 xl:py-[50px]
              3xl:px-[60px] 3xl:py-[60px]'
      >
        <div className='flex flex-col items-end gap-3 shrink-0 lg:hidden'>
          <h2 className='text-[#122D5C] font-bold tracking-wide text-lg text-center leading-6'>
            For business and when things get personal.
          </h2>
          <p className='text-[#37455C] font-medium text-xs  tracking-wide text-center'>
            Life doesn’t follow a script—and neither do legal issues. That’s why
            our podcast series explores real conversations around legal life
            events, from workplace matters to personal challenges. Whether
            you're an employer navigating new responsibilities or an individual
            seeking clarity, our exclusive insights help you understand your
            rights and options. Accessible anytime, right from your
            phone—because legal support should be there when you need it most.
          </p>
        </div>
        <div className='flex-shrink-0'>
          <img
            src={isMobile ? business : businessDesktop}
            className='w-[257px] h-[515px] lg:w-[257px] lg:h-[495px] xl:w-[238.87px] xl:h-[460px] 2xl:w-[389.43px] 2xl:h-[750px] 3xl:w-[449px] 3xl:h-[865px]'
          />
        </div>
        <div className='hidden lg:flex flex-col items-end gap-3 lg:gap-6 xl:gap-8 2xl:gap-10 lg:max-w-[560px] xl:max-w-[800px]  2xl:max-w-[860px] 3xl:max-w-[888px] shrink-0'>
          <h2
            className='text-[#122D5C] font-bold tracking-wide text-base leading-6 lg:text-xl lg:leading-8 xl:text-3xl xl:leading-10 
              3xl:text-[40px] 3xl:leading-none text-center'
          >
            For business and when things get personal.
          </h2>
          <p className='text-[#37455C] font-medium text-xs lg:text-sm lg:font-semibold xl:text-xl xl:leading-7 2xl:text-2xl 2xl:leading-8 2xl:font-bold tracking-wide text-center'>
            Life doesn’t follow a script—and neither do legal issues. That’s why
            our podcast series explores real conversations around legal life
            events, from workplace matters to personal challenges. Whether
            you're an employer navigating new responsibilities or an individual
            seeking clarity, our exclusive insights help you understand your
            rights and options. Accessible anytime, right from your
            phone—because legal support should be there when you need it most.
          </p>
        </div>
      </div>
    </div>
  )
}

export default BusniessInfo
